import gql from 'graphql-tag';

export const ACCOMMODATIONS_ACTIVITIES_OVERVIEW = gql`
  query accommodationsActivitiesOverview($businessOwnerId: Int) {
    accommodationsActivitiesOverview(businessOwnerId: $businessOwnerId) {
      activities {
        total
        available
        expired
      }
      accommodations {
        total
        available
        expired
      }
    }
  }
`;

export const RENTAL_ITEMS_OVERVIEW = gql `
query rentalItemsOverview($businessOwnerId: Int) {
    rentalItemsOverview(businessOwnerId: $businessOwnerId) {
      rentalItems {
        total
        available
        expired
      }
      
    }
  }

`;
